import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const base = "new-options/";
const equityBase = "new-equity/";
const revamp = config.revamp;
const optionConfigURL = {
    optionTable: config.jmw + revamp + config.jmw_content + base + "option-chain",
    understandingSection: config.jmw +
        config.jmw_market_env +
        config.jmw_market +
        "options/understanding-section-options",
    expiryDate: config.jmw + config.jmw_content + "search/symbolexpiry",
    fnoBan: config.jmw + revamp + config.jmw_content + equityBase + "fnobanlist",
    recommendations: "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/dev/revamp/new-options/recommendations",
    gainerLosers: config.jmw + revamp + config.jmw_content + base + "oi-gainers-losers",
    highestOI: config.jmw + revamp + config.jmw_content + base + "highest-oi",
    highestVolume: config.jmw + revamp + config.jmw_content + base + "highest-vol-growth",
};
export default optionConfigURL;
